import React from 'react'

import Box from '@mui/material/Box'

const IconsHeader = () => (
  <>
    <Box className="icon edit-icon" />
    <Box className="icon promotion-icon" />
    <Box className="icon surface-increased-icon" />
  </>
)

export default IconsHeader
